module.exports = __webpack_public_path__ + "img/tribe-logo-example.9c1d7320.svg";